import { call, put, takeEvery } from 'redux-saga/effects';
import api from '../common/api';
import { RESULT_REQUEST, resultSuccess, resultFailure, oidRegister, oidClear } from '../actions/actions';
import checkResponse from '../common/checkResponse';

function* handleRequest(action) {

  try {
    const response = yield call(api, action);
    const payload = yield response.json();

    if(!checkResponse(response, payload)) return;

    if( payload.sc === 0 && payload.errMsg == null ) {
      yield put(resultSuccess(payload));
      yield put(oidRegister(payload));
    } else {
      yield put(resultFailure(payload));
      yield put(oidClear(payload));
    }
  } catch(error) {
    console.log("error ==> ",error);
  }
}

const lotteryResultSaga = [takeEvery(RESULT_REQUEST, handleRequest)];
export default lotteryResultSaga;